import { Users, UserCheck, UserX } from 'lucide-react';
import { useTheme } from '../../zustand/ThemeStore';
import type { UserType } from '../../types/settings';

interface StatsCardsProps {
  users: UserType[];
}

export default function StatsCards({ users }: StatsCardsProps) {
  const darkMode = useTheme((state) => state.theme);

  const activeUsers = users.filter(u => u.status === 'unsuspended').length - 1;
  const revokedUsers = users.filter(u => u.status === 'suspended').length;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8">
      <div className={`rounded-lg sm:rounded-xl p-4 sm:p-5 shadow-md hover:shadow-lg transition-all ${
        darkMode 
          ? 'bg-[#0a1414] hover:bg-[#0f1919] border border-[#1a2424]' 
          : 'bg-white border border-gray-200'
      }`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs sm:text-sm ${
              darkMode ? 'text-gray-400' : 'text-[#373737]'
            }`}>
              Total Users
            </p>
            <p className={`text-2xl sm:text-3xl font-bold ${
              darkMode ? 'text-white' : 'text-[#053333]'
            }`}>{users.length - 1}</p>
          </div>
          <div className={`p-2.5 sm:p-3 rounded-lg ${
            darkMode
              ? 'bg-gradient-to-r from-[#1a9f6b]/20 to-[#148856]/20'
              : 'bg-gradient-to-r from-[#1a9f6b]/10 to-[#148856]/10'
          }`}>
            <Users className={`w-5 h-5 sm:w-6 sm:h-6 text-[#1a9f6b]`} />
          </div>
        </div>
      </div>

      <div className={`rounded-lg sm:rounded-xl p-4 sm:p-5 shadow-md hover:shadow-lg transition-all ${
        darkMode 
          ? 'bg-[#0a1414] hover:bg-[#0f1919] border border-[#1a2424]' 
          : 'bg-white border border-gray-200'
      }`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs sm:text-sm ${
              darkMode ? 'text-gray-400' : 'text-[#373737]'
            }`}>
              Active Users
            </p>
            <p className={`text-2xl sm:text-3xl font-bold ${
              darkMode ? 'text-white' : 'text-[#053333]'
            }`}>
              {activeUsers}
            </p>
          </div>
          <div className={`p-2.5 sm:p-3 rounded-lg ${
            darkMode
              ? 'bg-gradient-to-r from-green-900/30 to-emerald-900/30'
              : 'bg-gradient-to-r from-green-100 to-emerald-100'
          }`}>
            <UserCheck className={`w-5 h-5 sm:w-6 sm:h-6 ${
              darkMode ? 'text-green-400' : 'text-green-600'
            }`} />
          </div>
        </div>
      </div>

      <div className={`rounded-lg sm:rounded-xl p-4 sm:p-5 shadow-md hover:shadow-lg transition-all ${
        darkMode 
          ? 'bg-[#0a1414] hover:bg-[#0f1919] border border-[#1a2424]' 
          : 'bg-white border border-gray-200'
      }`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs sm:text-sm ${
              darkMode ? 'text-gray-400' : 'text-[#373737]'
            }`}>
              Revoked Access
            </p>
            <p className={`text-2xl sm:text-3xl font-bold ${
              darkMode ? 'text-white' : 'text-[#053333]'
            }`}>
              {revokedUsers}
            </p>
          </div>
          <div className={`p-2.5 sm:p-3 rounded-lg ${
            darkMode
              ? 'bg-gradient-to-r from-red-900/30 to-orange-900/30'
              : 'bg-gradient-to-r from-red-100 to-orange-100'
          }`}>
            <UserX className={`w-5 h-5 sm:w-6 sm:h-6 ${
              darkMode ? 'text-red-400' : 'text-red-600'
            }`} />
          </div>
        </div>
      </div>
    </div>
  );
}
